$(document).ready(function (e) {

    $('[data-toggle="tooltip"]').tooltip();

    $('.show-export-data').on('click', function(e){
        e.preventDefault();
        $('.nav-link').removeClass('active');
        $(this).addClass('active');

        $('#export-modal').modal('show');
    });

    $('#export-tables').on('change', function(e){
        let tables = $(this).val();

        if(tables.length){
            $.ajax({
                type : 'GET',
                url : '/export/tables',
                data : {
                    tables
                },
                success: function(res){
                    $('.export-tables-container').html(res);
                }
            })
        }
    });

    $(document).on('change', '.toggle-export-fields', function(e){
        let $export_field = $(this).parents('.card').find('.export-field');
        if($(this).is(':checked')){
            $export_field.prop('checked', true);
        }else{
            $export_field.prop('checked', false);
        }
    });

    $(document).on('change', '.toggle-section-fields', function(e){
        let $export_field = $(this).parents('.card').find('.section-export-field');
        if($(this).is(':checked')){
            $export_field.prop('checked', true);
        }else{
            $export_field.prop('checked', false);
        }
    });

    $(document).on('change', '.section-export-field', function(e){
        let $unchecked = $(this).parents('.card').find('.section-export-field:not(:checked)'),
            $toggle_export = $(this).parents('.card').find('.card-body').find('.toggle-section-fields');
        if($unchecked.length){
            $toggle_export.prop('checked', false);
        }else{
            $toggle_export.prop('checked', true);
        }
    });

    $('.export-data').on('click', function(e){
        let type = $(this).attr('data-type');
        let $export_tables = $('.export-table'),
            export_data = [];

        $export_tables.each(function(index, $table){
             let data = {
                 table: $($table).attr('data-table'),
                 filter: $($table).find('.export-table-filter').val(),
                 fields : []
             };

             let $fields = $($table).find('.export-field:checked');
             $fields.each(function(index, $field){
                 data.fields.push($($field).attr('data-field'));
             });

             export_data.push(data);
        });

        if(export_data.length){

            toastr.info(translation.export_started);
            let $spinner = $(this).find('.spinner-border'),
                $btn = $(this);
            $spinner.removeClass('d-none');
            $btn.prop('disabled', true);
            let win = window.open("", '_blank');

            $.ajax({
                type : 'GET',
                url : '/export/data',
                data : {
                    data: export_data,
                    type
                },
                success: function(res){
                    if(res){
                        win.location.href = res;
                        win.focus();
                    }

                    $spinner.addClass('d-none');
                    $btn.prop('disabled', false);
                }
            })
        }
    });
});